/**
 * MobileBottomNav — VU-Player-Pro inspired 4-tab bottom navigation.
 *
 * Renders on phones only (hidden ≥ md breakpoint). Tabs:
 *   • Live  — /player/browse/live_tv
 *   • Movies — /player/browse/movie
 *   • Series — /player/browse/series
 *   • Settings — /player/settings
 *
 * Stays visible across Browse / Search / Catch-up / Menu pages so users can
 * jump between sections without going through the home tile grid every time.
 */
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Tv, Film, Clapperboard, Settings as SettingsIcon } from "lucide-react";

const TABS = [
  { key: "live", path: "/player/browse/live_tv", label: "Live", icon: Tv, match: /^\/player\/browse\/live_tv/ },
  { key: "movies", path: "/player/browse/movie", label: "Movies", icon: Film, match: /^\/player\/browse\/movie/ },
  { key: "series", path: "/player/browse/series", label: "Series", icon: Clapperboard, match: /^\/player\/browse\/series/ },
  { key: "settings", path: "/player/settings", label: "Settings", icon: SettingsIcon, match: /^\/player\/settings/ },
];

export default function MobileBottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <nav
      data-testid="player-mobile-bottom-nav"
      className="vu-bottom-nav md:hidden fixed bottom-0 inset-x-0 z-40 flex"
      style={{
        paddingBottom: "env(safe-area-inset-bottom, 0px)",
      }}
    >
      {TABS.map((tab) => {
        const active = tab.match.test(pathname);
        const Icon = tab.icon;
        return (
          <button
            key={tab.key}
            data-testid={`player-bnav-${tab.key}`}
            onClick={() => navigate(tab.path)}
            className={`flex-1 flex flex-col items-center justify-center gap-1 py-2.5 mx-1 my-1.5 rounded-xl border-2 transition-all ${
              active
                ? "border-white bg-white/10 text-white"
                : "border-transparent text-white/55 hover:text-white"
            }`}
          >
            <Icon className="w-5 h-5" strokeWidth={1.8} />
            <span className="text-[10px] uppercase tracking-wider font-semibold">
              {tab.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
